import { Component } from '@angular/core';
import { UserModel } from 'src/app/wings-mobile/models/user/user.model';
import { WarehouseModel } from 'src/app/wings-mobile/models/warehouse/warehouse.model';
import { WarehouseService } from 'src/app/wings-mobile/services/warehouse/warehouse.service';
import { Globals } from 'src/app/wings-mobile/shared/globals/globals';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'user-location',
    templateUrl: './user-location.component.html',
    styleUrls: ['./user-location.component.css'],
    imports: [TranslatePipe]
})
export class UserLocationComponent {

	buildingCode: number = parseInt(this.globals.tokenData.fordSiteCode);
	environmentName: string = Globals.getEnvironment();

	constructor(
		private warehouseService: WarehouseService,
		public globals: Globals) {
		this.globals = globals;
		this.warehouseService = warehouseService;
	}

	ngOnInit() {
		this.findWarehouseName();

		switch (this.environmentName) {
			case "LOCAL":
				this.environmentName = "header.localEnvironment";
				break;
			case "DEV":
				this.environmentName = "header.devEnvironment";
				break;
			case "QA":
				this.environmentName = "header.qaEnvironment";
				break;
			case "PROD":
				this.environmentName = "";
				break;
			default:
				this.environmentName = "";
				break;
		}
	}

	findWarehouseName() {
		let userModelLocal: UserModel = JSON.parse(localStorage.getItem("user"));
		let modelLocal: WarehouseModel = userModelLocal?.warehouse;

		this.warehouseService.findByBuildingCodeC(this.buildingCode).subscribe({
			next: (res: WarehouseModel) => {
				if (modelLocal) {
					this.globals.user.warehouse = modelLocal;
				}
				else if (res.warehouseUidK != null) {
					this.globals.user.warehouse = res;
				} else {
					this.globals.user.warehouse.warehouseN = "NO WAREHOUSE";
				}
			},
			error: () => {
				if (modelLocal) {
					this.globals.user.warehouse = modelLocal;
				} else {
					this.globals.user.warehouse.warehouseN = "NO WAREHOUSE";
				}
			}
		});
	}
}

